import React from "react";
import { capitalizeFirstLetter } from "../../../utils/helper";

function ViewPartner({
  partner,
  onClose,
  onApprove,
  roleSelections,
  handleRoleChange,
  loadingUpdate,
}) {
  if (!partner) return null;  
  const isApproved = partner?.isApproved;

const ApprovalBadge = ({ status }) => {
  let className = "app-badge  ";
 let displayText = status; 
 
   if (status === "GANGLEADER") {
    className += "bg-label-navy ";
     displayText = "Captain";
  } 
    else if (status === "FIELDOFFICER") {
    className += "bg-label-wave ";
    displayText = "Field Officer";
  }else {
    className += "bg-light text-dark";
  }

  return <span className={className}>{displayText}</span>;
};

  return (
    <>    
      <div className="modal-backdrop show"></div>

      <div
        className="modal show d-block"
        id="ViewPartnerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ">           
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title fw-semibold">
                Partner Details:{" "}
                <span className="text-capitalize">
                  {partner.name || partner.mobileNumber}
                </span>
              </h6>
              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="p-3">
                <div className="row gy-3 ">
                  <div className="col-12 d-flex justify-content-between">
                    <span className="fw-semibold text-secondary">Role:</span>
                    <span>
                      {partner?.role &&(
                    <ApprovalBadge 
                              status={partner?.role }                            
                            />)}
                    </span>
                  </div>
                  <div className="col-12 d-flex justify-content-between">
                    <span className="fw-semibold text-secondary">Phone:</span>
                    <span className="text-black fw-bold">
                      <a href={`tel:+91${partner?.mobileNumber}`} onClick={(e) => e.stopPropagation()} className="text-black">{partner.mobileNumber}</a>
                    </span>
                  </div>
                  <div className="col-12 d-flex justify-content-between">
                    <span className="fw-semibold text-secondary">
                      KYC Status:
                    </span>
                    <span
                      className={`badge ${
                        partner.kycStatus === "APPROVED"
                          ? "bg-success"
                          : "bg-label-moon"
                      }`}
                    >
                      {capitalizeFirstLetter(partner.kycStatus) || "-"}
                    </span>
                  </div>
                </div>
              </div>

              {!isApproved && (
                <div
                  className="p-3 rounded mb-3"
                  style={{ backgroundColor: "#fdecea" }}
                >
                  <p className="mb-2 text-danger fw-semibold">
                    Action Required: Approval Pending
                  </p>
                  <p className="mb-2">
                    <strong>Select Approval Role:</strong>
                  </p>
                  <select
                    className="form-select"
                    value={roleSelections[partner._id] || ""}
                    onChange={(e) =>
                      handleRoleChange(partner._id, e.target.value)
                    }
                  >
                    <option value="">-- Select Role --</option>
                    {/* <option value="FIELDOFFICER">Field Officer</option> */}
                    <option value="GANGLEADER">Captain</option>
                  </select>
                </div>
              )}

              <hr className="my-3" />
            </div>          
            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary px-3"
                onClick={onClose}
              >
                Close
              </button>

              {!isApproved && (
                <button
                  type="button"
                  className="btn btn-primary px-3"
                  disabled={!roleSelections[partner._id] || loadingUpdate}
                  onClick={() =>
                    onApprove(partner._id, roleSelections[partner._id])
                  }
                >
                  {loadingUpdate ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Approving...
                    </>
                  ) : (
                    <>
                      <i className="bx bx-check"></i> Approve Partner
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewPartner;
